import React from 'react'
import PropTypes from 'prop-types'

// Embeds the HubSpot-hosted Discover page. The URL comes from Rails
// (GgGolfHubHelper::DISCOVER_URL) rather than being hardcoded here.
const DiscoverComponent = ({ discoverUrl }) => {
  if (!discoverUrl) { return null }

  return (
    <iframe
      className="discover-frame"
      src={discoverUrl}
      title={window.I18n.t('gg_golf_hub.dashboard.discover')}
      loading="lazy"
    />
  )
}

DiscoverComponent.propTypes = {
  discoverUrl: PropTypes.string,
}

export default DiscoverComponent
